import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicantInformationDetails from './ApplicationInformationDetails';
import CapacityReview from './CapacityReview';
import LegalStatus from './LegalStatus';
import OrganizationDocs from './OrganizationDocs';
import OrganizationStructure from './OrganizationStructure';

interface FileWithUrl {
  key: string;
  name: string;
  path: string;
  type: string;
  field: string;
  description: string;
  url: string;
}

export const CHDOApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  const handleDownload = (fieldKey: string) => {
    // Find all files in the files array that match this field
    const fileWithUrl = files.find((f: FileWithUrl) => f.key === fieldKey);
    if (fileWithUrl?.url) {
      window.open(fileWithUrl.url, '_blank');
    } else {
      console.error('URL not found for field:', fieldKey);
    }
  };

  console.log('Application Data:', files);

  return (
    <>
      <ApplicantInformationDetails data={applicationData?.step1} />

      <OrganizationDocs documents={applicationData?.step2} onDownload={handleDownload} />

      <LegalStatus data={applicationData?.step3} onDownload={handleDownload} />

      <OrganizationStructure data={applicationData?.step4} onDownload={handleDownload} />

      <CapacityReview data={applicationData?.step5} onDownload={handleDownload} />
    </>
  );
};
